import styled, { css } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${theme.co.neutral99};
    border-top: ${theme.bo.thinWidth} solid ${theme.co.neutral90};
    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    padding: ${theme.sz.s3} ${theme.sz.s4};
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    gap: ${theme.sz.s3};

    @media (max-width: ${theme.sz.md}) {
      flex-direction: column;
      gap: ${theme.sz.s2};
    }
  `,
);

export const SelectionInfo = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.neutral30};
    font-weight: ${theme.DEPRECATED_ty.mediumWeight};
  `,
);

export const Actions = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.sz.s2};
    align-items: center;
  `,
);
